__turbopack_context__.v({
  "ambient": "blog-module__pfx2eW__ambient",
  "article": "blog-module__pfx2eW__article",
  "articleBody": "blog-module__pfx2eW__articleBody",
  "articleHeader": "blog-module__pfx2eW__articleHeader",
  "articleTitle": "blog-module__pfx2eW__articleTitle",
  "categoryLink": "blog-module__pfx2eW__categoryLink",
  "categoryLinkActive": "blog-module__pfx2eW__categoryLinkActive",
  "categoryNav": "blog-module__pfx2eW__categoryNav",
  "cta": "blog-module__pfx2eW__cta",
  "ctaGlyph": "blog-module__pfx2eW__ctaGlyph",
  "ctaGo": "blog-module__pfx2eW__ctaGo",
  "discovery": "blog-module__pfx2eW__discovery",
  "faq": "blog-module__pfx2eW__faq",
  "heading": "blog-module__pfx2eW__heading",
  "indexCard": "blog-module__pfx2eW__indexCard",
  "indexList": "blog-module__pfx2eW__indexList",
  "inlineLink": "blog-module__pfx2eW__inlineLink",
  "layout": "blog-module__pfx2eW__layout",
  "resultCount": "blog-module__pfx2eW__resultCount",
  "searchInput": "blog-module__pfx2eW__searchInput",
  "searchLabel": "blog-module__pfx2eW__searchLabel",
  "shell": "blog-module__pfx2eW__shell",
  "shellInner": "blog-module__pfx2eW__shellInner",
  "sources": "blog-module__pfx2eW__sources",
  "tableWrap": "blog-module__pfx2eW__tableWrap",
  "tldr": "blog-module__pfx2eW__tldr",
});
